import { useEffect } from "react";
import { useNavigate } from "react-router";
import { getAndClearReturnUrl } from "@/helpers/apiBaseQuery";

/**
 * Checks sessionStorage for a saved return URL on mount and navigates to it.
 *
 * Used after the login flow redirects the user back to the app.
 * The URL is consumed (cleared) immediately to prevent repeat redirects.
 * Uses `replace: true` so the redirect doesn't pollute browser history.
 */
export const useReturnUrlRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const returnUrl = getAndClearReturnUrl();

    if (returnUrl) {
      navigate(returnUrl, { replace: true });
    }
  }, [navigate]);
};
